<template>
  <div class="presentation-owner">
    <aha-avatar
      :name="ownerName"
      :image="ownerAvatar"
      :id="ownerId"
      class="mr-1 flex-shrink-0"
    />
    <div class="presentation-owner__name">
      {{ ownerName }}
    </div>
  </div>
</template>

<script>
import EmailUtils from '@/utils/email'

export default {
  props: {
    data: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ownerAvatar() {
      return this.data.User && this.data.User.avatar
    },
    ownerId() {
      return this.data.User.id
    },
    ownerName() {
      if (this.data.User) {
        if (this.data.User.firstName) {
          return `${this.data.User.firstName} ${this.data.User.lastName}`
        }
        if (this.data.User.email) {
          return EmailUtils.getEmailName(this.data.User.email)
        }
      }
      return null
    },
  },

  methods: {

  },
}
</script>

<style lang="scss" scoped>
.presentation-owner {
  @apply flex flex-row items-center;
}
.presentation-owner__avatar {
  @apply rounded-full flex items-center justify-center mr-1;
  @apply text-base-0 uppercase;
  .__image {
    @apply rounded-full border border-primary-80;
  }
  width: 28px;
  height: 28px;
}
.presentation-owner__name {
  @apply capitalize truncate max-w-24 xl:max-w-40 text-xs;
}
</style>>
